/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 * @generated-id: 4f951f1842fb
 */

import * as z from "zod";

/**
 * Coordinate data for faces and custom regions.
 */
export type CoordinatesResponse = {
  faces?: Array<Array<number>> | undefined;
  custom?: Array<Array<number>> | undefined;
};

export const CoordinatesResponse$zodSchema: z.ZodType<CoordinatesResponse> = z
  .object({
    custom: z.array(z.array(z.number())).optional().describe(
      "Custom coordinate rectangles [x, y, width, height].",
    ),
    faces: z.array(z.array(z.int())).optional().describe(
      "Detected face coordinate rectangles [x, y, width, height].",
    ),
  }).describe("Coordinate data for faces and custom regions.");
